import React, { useState } from 'react'
import './Calculator.css'

const Calculator = () => {

  const [result, setResult] = useState("")

  const handleClick = (e) => {
    setResult(result + e.target.name)
  }

  const back = () => {
    setResult(result.slice(0, -1))
  }

  const clear = () => {
    setResult("");
  }

  const calculate = () => {
    try {
      // eslint-disable-next-line
      setResult(eval(result).toString());
    }
    catch {
      alert("error")
      setResult("")
    }
  }

  return (
    <div className='appp'>
      <h1>CALCULATOR</h1>
      <div className='calc' >
        <form>
        </form>
        <input className='inputdata' type="text" value={result} />
        <div className='keys'>
          <button id='clear' onClick={clear}>AC</button>
          <button id='back' onClick={back} >C</button>
          <button className='fun' name="+" onClick={handleClick}>+</button>
          <button className='btnnn' name="7" onClick={handleClick}>7</button>
          <button className='btnnn' name="8" onClick={handleClick}>8</button>
          <button className='btnnn' name="9" onClick={handleClick}>9</button>
          <button className='fun' name="-" onClick={handleClick}>-</button>
          <button className='btnnn' name="4" onClick={handleClick}>4</button>
          <button className='btnnn' name="5" onClick={handleClick}>5</button>
          <button className='btnnn' name="6" onClick={handleClick}>6</button>
          <button className='fun' name="*" onClick={handleClick}>*</button>
          <button className='btnnn' name="1" onClick={handleClick}>1</button>
          <button className='btnnn' name="2" onClick={handleClick}>2</button>
          <button className='btnnn' name="3" onClick={handleClick}>3</button>
          <button className='fun' name="/" onClick={handleClick}>/</button>
          <button className='btnnn' name="0" onClick={handleClick}>0</button>
          <button className='btnnn' name="." onClick={handleClick}>.</button>
          <button id="result" onClick={calculate}>=</button>
        </div>
      </div>
    </div>
  )
}

export default Calculator;